import React from 'react'

import TimePicker from 'react-bootstrap-time-picker'
import DatePicker from 'react-datepicker'
import Aux from 'hoc/ReactAux/ReactAux'
import moment from 'moment'
import time from 'utils/time'
import 'react-datepicker/dist/react-datepicker.css'
import './DatePickerOrder.scss'

const DatePickerOrder = (props) => {
  let datePickerComponent = null
  if (props.restaurantSelected && props.restaurantSelected.platter) {
    datePickerComponent =
      <Aux>
        <p>Select Delivery Time</p>
        <DatePicker
          selected={props.timeForOrder}
          onChange={props.handleTimeForOrder}
          dateFormat="DD/MM/YYYY HH:mm"
          minDate={moment()}
          showTimeSelect
          timeFormat="HH:mm"
          timeCaption="time"
          timeIntervals={10} />
      </Aux>
  } else if (props.restaurantSelected && props.restaurantSelected.forCollection === 'Y' ) {
    datePickerComponent =
      <div className="collection-time">
        <p>Select Collection Time</p>
        <TimePicker
          default="00:00"
          start={time.getCurrentHourMinutePlusMinutes(20)}
          end={props.restaurantSelected.openingHour.closeHour}
          onChange={props.handleTimeForOrder}
          value={props.timeForOrder}
          step={10} />
      </div>

  } else if(props.restaurantSelected && props.isDeliverAtHome) {
    datePickerComponent = <div className="collection-time">
      <p>Delivery between 12:00 pm to 1:00 pm</p>
    </div>
  } else if (props.restaurantSelected && props.ordersAhead) {
    datePickerComponent = <div className="checked-cutlery">
      <input
        checked={props.deliveryTomorrow}
        onChange={props.onDeliveryTomorrow}
        type="checkbox"
        id="deliveryTomorrow"
        name="deliveryTomorrow"
      />
      <label htmlFor="deliveryTomorrow">
        <b>Delivery Tomorrow</b>
      </label>
    </div>
  }
  return datePickerComponent

}

export default DatePickerOrder



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/DatePickerOrder/index.js